import { Component, Input, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { DateTime } from 'luxon';
import { BaseFormPage } from 'src/app/pages/base-form/base-form.page';

@Component({
  selector: 'app-prv-form-date-input',
  templateUrl: './prv-form-date-input.component.html',
  styleUrls: ['./prv-form-date-input.component.scss'],
})
export class PrvFormDateInputComponent  implements OnInit {
  @Input() control_name: string
  @Input() control_label: string  
  @Input() base_form_page: BaseFormPage
  @Input() size: string = 'full'
  // Optional override; when omitted, required is auto-detected from whether
  // the bound control has Validators.required.
  @Input() required: boolean
  // Optional luxon format for the button label, e.g. 'M/d/yyyy' renders
  // 7/23/2026. ion-datetime-button hardcodes "Jul 23, 2026" (formatOptions is
  // Ionic 8), so the label is overridden through its date-target slot instead.
  // Omitted = Ionic's default label.
  @Input() display_format: string

  constructor() { }

  ngOnInit() {}

  isRequired() {
    if (this.required !== undefined) return this.required
    return this.base_form_page.main_form.controls[this.control_name].hasValidator(Validators.required)
  }

  // Explicit mirror of the picker's confirmed value into the form control —
  // see the template comment on the ion-datetime.
  onPicked($event: any) {
    const value = $event?.detail?.value ?? null
    const control = this.base_form_page.main_form.controls[this.control_name]
    if (control && control.value !== value) {
      control.setValue(value)
      control.markAsDirty()
    }
  }

  clear() {
    this.base_form_page.main_form.controls[this.control_name].setValue(null)
    this.base_form_page.main_form.controls[this.control_name].markAsDirty()
    // Nulling the form control alone doesn't clear the ion-datetime's internal
    // display, so the datetime-button keeps showing the old date. Reset the
    // element directly to force the button to render empty.
    const el = document.getElementById('datetime_' + this.control_name) as any
    if (el && typeof el.reset === 'function') el.reset(undefined)
  }

  hasValue() {
    return this.base_form_page.main_form.controls[this.control_name].value != null
  }

  // Label for the datetime-button's date-target slot. Empty (no slotted
  // content) leaves Ionic's default label in place.
  displayValue(): string {
    if (!this.display_format) return ''
    const value = this.base_form_page.main_form.controls[this.control_name].value
    const dt = this.parseValue(value)
    return dt && dt.isValid ? dt.toFormat(this.display_format) : ''
  }

  private parseValue(value: any): DateTime | null {
    if (!value) return null
    if (value instanceof DateTime) return value
    if (value instanceof Date) return DateTime.fromJSDate(value)
    if (typeof value !== 'string') return null
    if (value.includes('T')) return DateTime.fromISO(value)
    if (value.length === 19) return DateTime.fromFormat(value, 'yyyy-MM-dd HH:mm:ss')
    return DateTime.fromFormat(value, 'yyyy-MM-dd')
  }

  hasErrorsClass() {
    if (this.base_form_page.main_form.controls[this.control_name].errors) return 'prv-select-error'
    return ''
  }

  hasErrors() {
    if (this.base_form_page.main_form.controls[this.control_name].errors) return true
    return false
  }

  hasError(error: string) {
    if (this.base_form_page.main_form.controls[this.control_name].errors![error]) return true
    return false
  }

/*   size_() {
    return 12    
  }
  size_sm() {
    if (this.size === 'full') return 12
    else if (this.size === 'half') return 12
    else if (this.size === 'third') return 6
    else return 6
  }
  size_md() {
    if (this.size === 'full') return 12
    else if (this.size === 'half') return 6
    else if (this.size === 'third') return 4
    else return 4
  }
  size_lg() {
    if (this.size === 'full') return 12
    else if (this.size === 'half') return 6
    else if (this.size === 'third') return 4
    else return 2
  } */
}
